<template>
    <div :class="badgeClasses">
        <div class="text-[9px]">{{ prefix }}</div>
        <div>{{ label }}</div>
        <div class="text-[9px]">{{ suffix }}</div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue'

    const props = withDefaults(
        defineProps<{
            label: string | number
            suffix?: string
            prefix?: string
            variant?: 'outline' | 'light' | 'neutral' | 'alert' | 'success' | 'warning' | 'dark' | 'dark-neutral'
            size?: 'xs' | 'sm' | 'lg'
        }>(),
        {
            size: 'sm',
            variant: 'neutral'
        }
    )

    const badgeClasses = computed(() => {
        const baseClasses = 'inline-flex items-center justify-center rounded-full font-bold text-center shadow-sm gap-[1px]'
        const sizeClasses = {
            xs: 'px-1 text-[10px] h-4 w-auto min-w-5 border',
            sm: 'px-1.5 py-1 text-[11px] h-5 w-auto min-w-6 border',
            md: 'px-1.5 py-1 text-[12px] h-6 w-auto min-w-6 border',
            lg: 'px-2 py-2 text-[13px] h-7 w-auto min-w-8 border'
        }
        const variantClasses = {
            outline: 'text-default bg-system-light border-neutral-200',
            light: 'text-default bg-system-light border-system-light',
            neutral: 'text-default bg-neutral-100 border-system-light',
            alert: 'text-system-light bg-red-500 border-system-light',
            success: 'text-default bg-green-500 border-system-light',
            warning: 'text-default bg-yellow-400 border-system-light',
            dark: 'text-system-light bg-system-dark border-system-light',
            'dark-neutral': 'text-system-dark bg-neutral-200 border-neutral-300'
        }
        return `${baseClasses} ${sizeClasses[props.size]} ${variantClasses[props.variant]}`
    })
</script>
